import { render, staticRenderFns } from "./AddUnavailableBlock.vue?vue&type=template&id=0cd8410a&scoped=true"
import script from "./AddUnavailableBlock.vue?vue&type=script&lang=js"
export * from "./AddUnavailableBlock.vue?vue&type=script&lang=js"
import style0 from "./AddUnavailableBlock.vue?vue&type=style&index=0&id=0cd8410a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd8410a",
  null
  
)

export default component.exports